/**
 * A href the v2 router can keep. Same-origin paths stay in-app: the v2
 * shell serves every path when v2 is selected, including /account.
 */
export function isInAppHref(href: string): boolean {
  if (!href.startsWith('/') || href.startsWith('//')) {
    return false;
  }
  return true;
}
